<mat-table [dataSource]="data" [trackBy]="trackByFn" class="ca-table">
    @for (column of columns; track column) {
        <ng-container [matColumnDef]="column.name">
            <mat-header-cell *matHeaderCellDef [style.flex]="column.flex">
                <div class="flex items-center gap-1">
                    <div class="ca-text-md ca-bold">{{ column.title | translate }}</div>
                    @if (column.orderBy) {
                        @if (order?.orderBy === column?.orderBy) {
                            <button mat-icon-button class="ca-button ca-button-s" (click)="onOrderChange(column.orderBy, order?.orderType)">
                                <ca-icon icon="order-{{ order?.orderType | lowercase }}" class="ca-icon-auto">
                                    <span class="path1"></span><span class="path2"></span>
                                </ca-icon>
                            </button>
                        } @else {
                            <button mat-icon-button class="ca-button ca-button-s" (click)="onOrderChange(column.orderBy)">
                                <ca-icon icon="order" class="ca-icon-auto"></ca-icon>
                            </button>
                        }
                    }
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let row; let i = index" [style.flex]="column.flex">
                @if (column.templateRef) {
                    <div class="cell-wrapper">
                        <ng-container *ngTemplateOutlet="column.templateRef; context: { $implicit: { row: row, index: i } }">
                        </ng-container>
                    </div>
                } @else {
                    <div class="cell-wrapper cell-wrapper-ellipsis">
                        <ng-container>{{ row[column.name] ?? '' }}</ng-container>
                    </div>
                }
            </mat-cell>
        </ng-container>
    }

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
        *matRowDef="let row; let index = index; columns: displayedColumns"
        [ngClass]="getRowClasses(row)"
        (click)="rowClick.emit(row)"
        [cdkContextMenuDisabled]="!contextMenuTemplateRef"
        [cdkContextMenuTriggerFor]="contextMenuTemplateRef"
        [cdkContextMenuTriggerData]="{ $implicit: { row: row, index: index } }"
    ></mat-row>
</mat-table>
